import React, { useEffect, useState, useRef } from "react";

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/navigation-prev.svg";
import SuccessIcon from "../../assets/svg/success.svg";
import ErrorIcon from "../../assets/svg/close-red.svg";
import RoomImage from "../../assets/png/room-view-image.png";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parse } from "date-fns";
import axios from "axios";
import { Form, Button, Container, InputGroup } from "react-bootstrap";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../common/Header";
import { getCookie } from "../getcookie.js";
import LoaderModal from "../common/Loader.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useGlobal } from "../../GlobalContext";
export default function MyBookingView() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const scrollRefs = useRef();

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    alert(`Submitted Value: ${emailInputValue}`);
  };

  const [meetingRoomDetails, setMeetingRoom] = useState({});
  const [isShowError, setShowError] = useState(false);
  const [isProceed, setProceed] = useState(false);
  const [isConfirmBooking, setConfirmBooking] = useState(false);

  const [titleInputValue, setTitleInputValue] = useState("");
  const [companyInputValue, setCompanyInputValue] = useState("");
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [emailInputValue, setEmailInputValue] = useState("");
  const handleTitleChange = (event) => {
    setTitleInputValue(event.target.value); // Update state with input value
  };

  const [selectedCategory, setCategoryValue] = useState("");
  const [selectedSlot, setSlotValue] = useState("30 mins");
  const [selectedBookId, setBookId] = useState([]);

  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openModal = (id) => {
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [availableList, setAvailable] = useState(["Ac", "Projector", "TV & Speaker"]);
  const [inviteEmails, setInviteEmail] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const menuBoxInactive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center" };
  const menuBoxActive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234" };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#842234" };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: "#1E1E1E" };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };
  const title = { fontSize: "32px", fontWeight: "700", color: "#1E1E1E" };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: "#81878C" };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: "#1E1E1E" };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: "#81878C", marginTop: "8px" };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: "#81878C", marginBottom: "8px" };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: "#21272C" };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: "#1E1E1E" };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: "#842234" };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: "#1E1E1E" };
  const officeTitle = { marginTop: "16px", marginBottom: "8px", fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#1E1E1E" };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 0.8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "328px",
      height: "229px",
      textAlign: "center",
    },
  };

  const handleCategoryClick = (category) => {
    setCategoryValue(category);
  };

  useEffect(() => {
    setSelectedMenu("My Bookings");
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(apiUrl + `booking/` + id, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          Authorization: getCookie("mawalog"),
        },
      });

      if (response.data.success === true) {
        console.log("booking:", response.data.booking);
        setMeetingRoom(response.data.booking);
        setAvailable(response.data.booking.available ?? []);
        setInviteEmail(response.data.booking.emails ?? []);
      }
      console.log("Room List:", roomList);
      console.log("Room List Length:", roomList.length);
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const cancelBooking = async (id) => {
    setErrorMessage("");
    setLoading(true);
    setError(null);

    try {
      const data = {};
      const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios.put(apiUrl + `cancel_booking/` + id, data, { headers: headers }).catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 500) {
            setErrorMessage(error.response.data.message);
          }
        } else {
          console.error("Request failed:", error.message);
        }
      });

      // const data = await response.json();
      if (response.data.success === true) {
        fetchOptions();
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkInOutMeeting = async (id, status) => {
    setErrorMessage("");
    setLoading(true);
    setError(null);

    try {
      const data = {};
      const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios
        .put(apiUrl + (status === "Pending" ? "check_in_booking" : "check_out_booking") + "/" + id, data, { headers: headers })
        .then((response) => {
          console.log("Response status:", response.status); // Check actual status
          console.log("Response data:", response.data);
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 500) {
              setErrorMessage(error.response.data.message);
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });
      console.log("response.status", response.status);
      console.log("message", response.data.message);
      // const data = await response.json();
      if (response.status === 200) {
        if (response.data.success === true) {
          fetchOptions();
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {/* <Header selectedTab={'My Bookings'}/> */}

      <Row className="flex-wrap px-3" style={{ height: "calc(100vh - 68px)", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: "center" }}>
        <Col xl={8} style={{ padding: "16px", justifyContent: "center" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1e1e1e" }}>My Bookings</div>
            &nbsp;&nbsp; <ArrowNextIcon />
            &nbsp;&nbsp;
            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1e1e1e" }}>{meetingRoomDetails["room"] ?? ""}</div>
            &nbsp;&nbsp; <ArrowNextIcon />
            &nbsp;&nbsp;
            <div style={{ fontSize: "13px", fontWeight: "500", color: "#842234" }}>Booking details details</div>
          </div>
          <div className="mt-2 mb-3">
            {/*  <img src={meetingRoomDetails['image']!=null && meetingRoomDetails['image']!=''?meetingRoomDetails['image']: RoomImage} className="w-100 mt-3" alt="room" style={{  height: '279px', }} /> */}
            {(meetingRoomDetails.images === undefined || meetingRoomDetails.images.length === 0) && <img src={meetingRoomDetails["image"] != null && meetingRoomDetails["image"] !== "" ? meetingRoomDetails["image"] : RoomImage} alt="room" className="w-100" style={{ height: "279px" }} />}
            {meetingRoomDetails.images !== undefined && meetingRoomDetails.images.length > 0 && (
              <Slider {...settings}>
                {meetingRoomDetails.images.map((img, index) => (
                  <div key={index}>
                    <img src={img} alt={`Slide ${index}`} style={{ width: "100%", height: "279px", objectFit: "scale-down" }} />
                  </div>
                ))}
              </Slider>
            )}
          </div>
          <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#ffffff" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1E1E1E" }}>{meetingRoomDetails["room"] ?? ""}</div>

                  <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#842234" }}>{meetingRoomDetails["capacity"] ?? "0"} Seater</div> &nbsp;&nbsp; <div style={{ width: "3px", height: "3px", backgroundColor: "#D9D9D9" }}></div>&nbsp;&nbsp;
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#81878C" }}>{meetingRoomDetails["category"] ?? ""}</div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", padding: "8px", borderRadius: "12px", background: "#FFF0F3" }}>
                <div style={{ width: "36px", height: "36px", borderRadius: "100px" }}>
                  <img src={meetingRoomDetails["org_image"] != null && meetingRoomDetails["org_image"] != "" ? meetingRoomDetails["org_image"] : RoomImage} alt="org" style={{ width: "36px", height: "36px", borderRadius: "100px" }} />
                </div>
                <div style={{ marginLeft: "8px" }}>
                  <div style={{ fontSize: "13px", fontWeight: "500", color: "#1E1E1E" }}>{meetingRoomDetails["office"] ?? ""}</div>
                  <div style={{ fontSize: "12px", fontWeight: "400", color: "#842234" }}>{meetingRoomDetails["floor_label"] ?? ""}</div>
                </div>
              </div>
            </div>
            &nbsp;&nbsp;
            <div style={availableTitle}>Available :</div>
            <Col lg={8} style={{ display: "flex", flexWrap: "wrap" }}>
              {availableList != null &&
                availableList.map((available, index) => (
                  <div key={`${index}-available`} style={{ height: "24px", marginRight: "6px", marginBottom: "4px", paddingLeft: "8px", paddingRight: "8px", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#F5F7F9" }}>
                    <div style={availableName}>{available}</div>
                  </div>
                ))}
            </Col>
          </div>
          {!isProceed && (
            <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#ffffff" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <div style={{ fontSize: "15px", fontWeight: "700", color: "#1E1E1E" }}>Slot date & time</div>
                    <div style={{ fontSize: "15px", fontWeight: "500", color: "#842234" }}>{meetingRoomDetails["date"] ?? ""}</div>
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div style={{ display: "flex" }}>
                    {meetingRoomDetails["status"] === "Pending" && (
                      <div
                        onClick={() => {
                          cancelBooking(meetingRoomDetails["id"]);
                        }}
                        style={{ cursor: "pointer", width: "180px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#ffffff", border: "1px solid #E5E5E5" }}>
                        <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}>Cancel Booking</div>
                      </div>
                    )}
                    {meetingRoomDetails["status"] === "Pending" && (
                      <div
                        onClick={() => {
                          checkInOutMeeting(meetingRoomDetails["id"], meetingRoomDetails["status"]);
                        }}
                        style={{ cursor: "pointer", width: "135.5px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                        <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Check In</div>
                      </div>
                    )}

                    {meetingRoomDetails["status"] === "In-Progress" && (
                      <div
                        onClick={() => {
                          checkInOutMeeting(meetingRoomDetails["id"], meetingRoomDetails["status"]);
                        }}
                        style={{ cursor: "pointer", width: "135.5px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                        <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Checkout</div>
                      </div>
                    )}

                    {meetingRoomDetails["status"] === "Completed" && (
                      <div className="px-3" style={{ height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", background: "#ECFFF4" }}>
                        <img src={SuccessIcon} style={{ width: "32px", height: "32px" }} />
                        &nbsp; <div style={{ fontSize: "14px", fontWeight: "700", color: "#20824A" }}>Checked out</div>
                      </div>
                    )}

                    {meetingRoomDetails["status"] === "Cancelled" && (
                      <div className="px-3" style={{ height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={ErrorIcon} style={{ width: "22px", height: "22px" }} /> &nbsp; <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}>Cancelled</div>
                      </div>
                    )}

                    {meetingRoomDetails["status"] === "Expired" && (
                      <div style={{ height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={ErrorIcon} style={{ width: "22px", height: "22px" }} />
                        &nbsp; <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}>Expired</div>
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}> {errorMessage} </div>
                </div>
              </div>
              <Row>
                <Col lg={6}>
                  <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#F5F7F9" }}>
                    <div style={{ fontSize: "13px", fontWeight: "400", color: "#21272C" }}>Checked in Time</div>
                    <div style={{ fontSize: "15px", fontWeight: "500", color: "#842234" }}>{meetingRoomDetails["check_in"] ?? "---"}</div>
                  </div>
                </Col>
                <Col lg={6}>
                  <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#F5F7F9" }}>
                    <div style={{ fontSize: "13px", fontWeight: "400", color: "#21272C" }}>Checked out Time</div>
                    <div style={{ fontSize: "15px", fontWeight: "500", color: "#842234" }}>{meetingRoomDetails["check_out"] ?? "---"}</div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <Row>
            <Col lg={6}>
              <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#ffffff" }}>
                <div style={{ fontSize: "15px", fontWeight: "700", color: "#1E1E1E" }}>Meeting details</div>
                <div style={{ marginTop: "8px", fontSize: "13px", fontWeight: "400", color: "#81878C" }}>Title</div>
                <div style={{ marginTop: "4px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }}>{meetingRoomDetails["title"] ?? "---"}</div>

                <div style={{ marginTop: "12px", fontSize: "13px", fontWeight: "400", color: "#81878C" }}>Company Name</div>
                <div style={{ marginTop: "4px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }}>{meetingRoomDetails["company_name"] ?? "---"}</div>

                <div style={{ marginTop: "12px", fontSize: "13px", fontWeight: "400", color: "#81878C" }}>Description</div>
                <div style={{ marginTop: "4px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }}>{meetingRoomDetails["description"] ?? "---"}</div>
              </div>
            </Col>
            <Col lg={6}>
              <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#ffffff" }}>
                <div style={{ fontSize: "15px", fontWeight: "700", color: "#1E1E1E" }}>Invited guests {inviteEmails.length}</div>
                &nbsp;
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {inviteEmails.map((item, emailIndex) => (
                    <div key={`${emailIndex}-email`} style={{ height: "36px", marginLeft: "8px", marginRight: "8px", paddingLeft: "8px", paddingRight: "8px", borderRadius: "8px", display: "flex", justifyContent: "start", alignItems: "center", backgroundColor: "#F5F7F9" }}>
                      <label style={{ fontSize: "13.5px", fontWeight: "500", color: "#1E1E1E", display: "flex", justifyContent: "start", alignItems: "center" }}>{item}</label>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          &nbsp;&nbsp;
          {isProceed && !isConfirmBooking && (
            <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#ffffff" }}>
              <div style={{ fontSize: "20px", fontWeight: "800", color: "#1E1E1E" }}>Send Email Invites?</div>
              <div style={{ fontSize: "14px", fontWeight: "400", color: "#8790A1" }}>An email invite will be sent to your guests</div>
              <Form>
                <Form.Group controlId="companyNameInput" style={{ marginTop: "8px" }}>
                  <Form.Label style={{ fontSize: "14px", fontWeight: "400", color: "#1E1E1E" }}>Email Address </Form.Label>
                  <InputGroup>
                    <Form.Control
                      className="custom-input"
                      type="text"
                      placeholder="Enter here..."
                      value={emailInputValue}
                      onChange={(event) => {
                        setEmailInputValue(event.target.value); // Update state with input value
                      }}
                    />
                    <InputGroup.Text>
                      <div
                        onClick={() => {
                          if (emailInputValue !== "") {
                            const index = inviteEmails.findIndex((element) => element === emailInputValue);
                            if (index === -1) {
                              setInviteEmail((prevEmails) => {
                                prevEmails.push(emailInputValue);
                                setEmailInputValue("");
                                return prevEmails;
                              });
                            }
                          }
                        }}
                        style={{ cursor: "pointer", height: "36px", paddingLeft: "8px", paddingRight: "8px", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                        <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Add</div>
                      </div>
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                &nbsp;
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#842234" }}>Added guests : {inviteEmails.length}</div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {inviteEmails.map((item, emailIndex) => (
                    <div key={`${emailIndex}-email`} style={{ height: "36px", marginLeft: "8px", marginRight: "8px", paddingLeft: "8px", paddingRight: "8px", borderRadius: "8px", display: "flex", justifyContent: "start", alignItems: "center", backgroundColor: "#F5F7F9" }}>
                      <label style={{ fontSize: "13.5px", fontWeight: "500", color: "#1E1E1E", display: "flex", justifyContent: "start", alignItems: "center" }}>{item}</label>
                      &nbsp;
                      <SlotCloseIcon
                        onClick={() => {
                          const updatedItems = [...inviteEmails];
                          updatedItems.splice(emailIndex, 1);
                          setInviteEmail(updatedItems);
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div xs={12} style={{ display: "flex" }}>
                  <div
                    onClick={() => {
                      setProceed(false);
                    }}
                    className="w-50 mt-3"
                    style={{ height: "36px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#ffffff", border: "1px solid #E5E5E5" }}>
                    <div style={{ cursor: "pointer", fontSize: "14px", fontWeight: "700", color: "#1E1E1E" }}>
                      <BackIcon />
                      &nbsp;Back
                    </div>
                  </div>
                  <div onClick={() => {}} className="w-50 mt-3" style={{ height: "36px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                    <div style={{ cursor: "pointer", fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Invite & Confirm Booking</div>
                  </div>
                </div>
              </Form>
            </div>
          )}
          &nbsp;&nbsp;
          {isProceed && isConfirmBooking && (
            <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", height: "434px", display: "flex", justifyContent: "center", alignItems: "center", background: "#ffffff" }}>
              <div style={{ textAlign: "center" }}>
                <SuccessIcon />
                <div style={{ fontSize: "24px", fontWeight: "700", color: "#1E1E1E", placeItems: "center" }}>Congratulations !</div>
                <div style={{ fontSize: "14px", fontWeight: "400", color: "#8790A1" }}>Booking Successfully Completed.</div>
                <div style={{ fontSize: "14px", fontWeight: "400", color: "#8790A1" }}>Guest will receive respective emails accordingly.</div>
                &nbsp;
                <div style={{ textAlign: "center" }}>
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{ height: "36px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                    <div style={{ cursor: "pointer", fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Okay, done</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <LoaderModal show={loading} />
    </Container>
  );
}
